import { Item, SelectionList } from "@components/SelectionList";

interface VerticalTabsProps {
  title?: string;
  tabs: Item[];
  selectedTab?: string;
  onSelectedTabChange: (nextId: string) => void;
}

export const VerticalTabs = ({
  title,
  tabs,
  selectedTab,
  onSelectedTabChange
}: VerticalTabsProps) => {
  const selectedItem = tabs.find(t => t.id === selectedTab);
  const handleSelectedItemChange = (next: Item) => onSelectedTabChange(next.id);

  return (
    <SelectionList
      title={title}
      items={tabs}
      selectedItem={selectedItem}
      onSelectedItemChange={handleSelectedItemChange}
    />
  );
};
